module.exports = __webpack_public_path__ + "img/pingbase.dae2c41d.png";